import axios from "axios";
import { DermobellaResponse, DermopicoResponse } from "types/api";
import { AppData } from "types/app";
import { formatDate } from "lib/formatDate";
import { getApiUrls } from "./getApiUrls";
import { formatResults } from "lib/formatResults";
import { getVisibleResults } from "lib/getVisibleResults";

export const fetchAppData = async () => {
  const urlParams = new URLSearchParams(window.location.search);
  const batchId = urlParams.get("batch_id") || "";
  const consultant_company_id = urlParams.get("consultant_company_id") || "";

  let lang = urlParams.get("lang") || "";
  if (lang === "zhhant") lang = "zh-Hant";
  if (lang === "zhhans") lang = "zh-Hans";

  const { GET_RESULTS_URL, appName } = getApiUrls();

  const resultsUrl = `${GET_RESULTS_URL}/${batchId}`;
  const { data } = await axios.get<DermobellaResponse | DermopicoResponse>(
    resultsUrl,
  );
  const results = "body" in data ? data.body : data.data;

  const formatedResults = formatResults({ results, appName });
  const { barGraphs, radars } = getVisibleResults({
    results: formatedResults,
    appName,
  });

  let time = "";
  let date = "";

  if (results.length) {
    time = formatDate(results[0].date);
    date = time.split(".")?.shift() || "";
  }

  return {
    name: "",
    surname: "",
    gender: "male",
    time,
    date,
    results: formatedResults,
    barGraphs,
    radars,
    lang,
    appName,
    customization: {},
    consultant_company_id,
  } as AppData;
};
